<template>
    <div class="settings">
        <settings-slider
            v-model="model.blockWidth"
                
            v-bind:label="resource('TemplateDefaultSettings_BlockWidth_Label')"
            
            v-bind:min="250"
            v-bind:max="900"
            value-suffix="px"
        >
        </settings-slider>
        
        <settings-slider
            v-model="model.blockPadding"
                
            v-bind:label="resource('TemplateDefaultSettings_BlockPadding_Label')"
            value-suffix="px"
        >
        </settings-slider>
        
        <settings-dropdown
            v-model="model.headingSize"
                
            v-bind:label="resource('TemplateDefaultSettings_HeadingSize_Label')"
            v-bind:options="headingSizes"
        >
        </settings-dropdown>
        
        <settings-dropdown
            v-model="model.font"    
            
            v-bind:label="resource('TemplateDefaultSettings_Font_Label')"
            v-bind:options="fonts"

            value-field="value"
            text-field="text"
        >
        </settings-dropdown>
        
        <settings-dropdown
            v-model="model.fontSize"    
            
            v-bind:label="resource('TemplateDefaultSettings_FontSize_Label')"
            v-bind:options="fontSizes"
            
            value-field="value"
            text-field="text"
        ></settings-dropdown>
        
        <settings-color-picker
            v-model="model.textColor"

            v-bind:label="resource('TemplateDefaultSettings_TextColor_Label')"
        >
        </settings-color-picker>
        
        <settings-toggle
            v-model="model.boldText"
            
            v-bind:label="resource('TemplateDefaultSettings_BoldText_Label')"
        >
        </settings-toggle>
        
        <settings-toggle
            v-model="model.italicText"
            
            v-bind:label="resource('TemplateDefaultSettings_ItalicText_Label')"
        >
        </settings-toggle>
        
        <settings-radio
            v-model="model.textAlignment"
                
            v-bind:options="textAlignmentOptions"
            v-bind:label="resource('TemplateDefaultSettings_TextAlignment_Label')"

            value-field="value"
            text-field="text"
        >
        </settings-radio>
    </div>
</template>

<script>
    import settingsMixin from '../../Mixins/settings';
    import resourceMixin from '../../../../Util/Mixins/resources';
    
    import headingSizes from '../../CustomStylingOptions/heading-sizes';
    import fonts from '../../CustomStylingOptions/fonts';
    import fontSizes from '../../CustomStylingOptions/font-sizes';
    import textAlignmentOptions from '../../CustomStylingOptions/text-alignment';
    
    export default {
        name: "template-default-settings",
        mixins: [settingsMixin, resourceMixin],
        methods: {
            upperCaseFirst(input){
                //Uppercase first char, append rest of string
                return `${input.charAt(0).toUpperCase()}${input.slice(1)}`;
            }
        },
        computed: {
            fontSizes(){
                return fontSizes.map(fs => ({
                    value: fs,
                    text: fs
                }));
            },
            fonts(){
                const vm = this;
                
                return fonts.map(f => ({
                    value: f,
                    text: vm.upperCaseFirst(f)
                }))
            },
            textAlignmentOptions(){
                const vm = this;
                
                return textAlignmentOptions.map(t => ({
                    value: t,
                    text: vm.upperCaseFirst(t)
                }));
            }
        },
        data: () => ({
            headingSizes
        })
    };
</script>
